<div  class="card border-0 rounded-5 shadow-sm mb-3" data-bs-toggle="modal" data-bs-target="#group_feed_modal">
  <div class="card-body p-3">
    <!-- Profile Section -->
    <div class="d-flex align-items-center">
      <div class="input-container flex-grow-1">
        <input type="text text-xxs"
               class="form-control bg-light border-0"
               placeholder="Write something ..."
               aria-label="Post content">
      </div>
    </div>
    <hr class="my-2 d-none d-sm-flex">
    <!-- Action Buttons -->
    <div class="d-flex justify-content-between d-none d-sm-flex">
      <span class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-danger">
        <i class="bi bi-file-earmark-pdf action-icon"></i>
        <span class="text-xs ms-2 d-none d-md-inline">Document</span>
      </span>
      <span class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-success">
        <i class="bi bi-images action-icon"></i>
        <span class="text-xs ms-2 d-none d-md-inline">Photo/video</span>
      </span>
      <span class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-warning">
        <i class="bi bi-record-circle action-icon"></i>
        <span class="text-xs ms-2 d-none d-md-inline">Recordings</span>
      </span>
    </div>
  </div>
</div>


<teleport to="body">
  <div class="modal fade" id="group_feed_modal" tabindex="-1" aria-labelledby="createGroupFeedModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-m modal-dialog-centered">
      <div class="modal-content rounded-5 shadow">
        <div class="modal-header">
          <h5 class="modal-title" id="createGroupFeedModalLabel">Create group feed</h5>
          <button type="button" class="close-button" data-bs-dismiss="modal" aria-label="Close">
            <i class="bi bi-x fw-bold"></i>
          </button>
        </div>
        <form @submit.prevent="create_group_feed" class="p-2">
          <div class="post-content">
            <div class="user-info">
              <div class="user-avatar">
                <img src="@/assets/images/user.png" alt="User Avatar">
              </div>
              <div>
                <div class="user-name mb-0">{{user_details.first_name}} {{user_details.last_name}}</div>
              </div>
            </div>
            <!-- Feed Name -->
            <div class="mb-3 mt-3">
              <label for="group_report_name" class="form-label text-xs fw-500">Feed Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control rounded-5 text-xs" id="group_report_name" placeholder="Enter feed name"
                v-model="group_report_name">
              <p v-if="errors.group_report_name" class="text-danger text-xs">{{ errors.group_report_name }}</p>
            </div>
            <!-- Feed Description -->
            <div class="mb-3">
              <label class="form-label text-xs fw-500">Description <span class="text-danger">*</span></label>
              <QuillEditor theme="snow" v-model="group_feed_description" ref="quillGroupFeedEditorRef" class="quill-editor"
                placeholder="Enter your description here..." toolbar="full" />
              <div v-if="errors.group_feed_description" class="error-message">
                {{ errors.group_feed_description }}
              </div>
            </div>
            <div class="textarea-container">
              <!-- ...existing file/image/audio upload UI... -->
              <div v-if="group_file_name" class="text-xs text-secondary fst-italic mt-1">
                <span class="fw-500">File name:</span> {{ group_file_name }}
              </div>
              <div v-if="group_file_error" class="text-xs text-danger fst-italic mt-1">{{ group_file_error }}</div>
              <div v-if="group_image_preview" class="mt-2">
                <img :src="group_image_preview" alt="Preview" class="img-fluid rounded" style="max-width: 200px; max-height: 200px;" />
              </div>
            </div>
          </div>
          <div class="add-to-post d-flex align-items-center justify-content-between">
            <div class="add-to-post-text">Add to your group feed</div>
            <div class="d-flex flex-row align-items-center">
              <label for="groupFileInput" class="file-upload post-option"><i class="bi bi-images icon-photo"></i>/<i class="bi bi-filetype-docx icon-more"></i></label>
              <input type="file" id="groupFileInput" class="file-input d-none" @change="handleGroupFileUpload" />
              <label for="groupAudioInput" class="post-option"> <i class="bi bi-music-note-beamed icon-emoji"></i></label>
              <input type="file" accept="audio/*" id="groupAudioInput" class="file-input d-none" @change="handleGroupAudioUpload" />
              <div v-if="group_audio_error" class="text-xs text-danger fst-italic mt-1">{{ group_audio_error }}</div>
              <button class="post-option" @click="startGroupRecording" v-if="!isGroupRecording">
                <i class="bi bi-mic icon-location"></i>
              </button>
              <button class="post-option" @click="stopGroupRecording" v-if="isGroupRecording">
                <i class="bx bx-stop icon-location"></i>
              </button>
            </div>
          </div>
          <div class="post-button-container">
            <p v-if="errors.group_feed_details" class="text-danger text-xs">{{ errors.group_feed_details }}</p>
            <button class="btn btn-primary w-100 rounded-3 shadow-sm" type="submit">Post</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>
